import React, { useEffect } from 'react';
import { ClipboardCheck } from 'lucide-react';
import CloseButton from './ui/CloseButton';

const PURPLE_GRADIENT = 'linear-gradient(145deg,#7c3aed,#5b21b6)';
const badge = (bg, color) => ({ background: bg, color, fontSize: '0.8rem', padding: '0.4rem 0.6rem', borderRadius: '0.4rem' });

// Shows the outcome of a GRE "Generate Published/Micro" run: created quizzes (all unpublished)
// plus, for published, the reason generation stopped (e.g. essays or a section pool exhausted).
const GreGenerateReportModal = ({ report, kind = 'Published', onClose }) => {
    useEffect(() => {
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = prev; };
    }, []);

    if (!report) return null;
    const created = report.created || [];

    return (
        <div style={{
            position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100, padding: '1rem',
        }}>
            <div style={{
                backgroundColor: '#ffffff', borderRadius: '0.9rem',
                boxShadow: '0 10px 25px -5px rgba(0,0,0,0.3)', width: '90%', maxWidth: 'min(680px, 96vw)',
                maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden',
            }}>
                <div style={{ background: PURPLE_GRADIENT, color: '#fff', padding: '1.1rem 1.25rem', position: 'relative', flexShrink: 0 }}>
                    <CloseButton onClick={onClose} />
                    <h2 style={{ fontSize: '1.3rem', fontWeight: 700, margin: 0, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <ClipboardCheck style={{ width: '1.25rem', height: '1.25rem' }} /> GRE {kind} Test Report
                    </h2>
                </div>

                <div style={{ flex: 1, overflowY: 'auto', padding: '1rem 1.25rem' }}>
                    <div className="d-flex flex-wrap gap-2 mb-3 align-items-center">
                        <span style={badge('#dcfce7', '#166534')}>Created: {created.length}</span>
                        {report.stopped_reason ? (
                            <span className="text-muted small">Stopped: {report.stopped_reason}</span>
                        ) : null}
                    </div>

                    {created.length > 0 ? (
                        <div className="mb-2">
                            <div className="fw-semibold text-success small mb-1">Newly created (unpublished)</div>
                            <ul className="mb-0 small">
                                {created.map(r => (
                                    <li key={r.quiz_id}>{r.title} <span className="text-muted">(#{r.quiz_id}, {r.questions} questions)</span></li>
                                ))}
                            </ul>
                        </div>
                    ) : (
                        <p className="text-muted mb-0">No tests were created. {report.stopped_reason}</p>
                    )}
                </div>

                <div style={{ borderTop: '1px solid #e5e7eb', padding: '0.85rem 1.25rem', display: 'flex', justifyContent: 'flex-end', flexShrink: 0 }}>
                    <button className="btn btn-primary" onClick={onClose}>Done</button>
                </div>
            </div>
        </div>
    );
};

export default GreGenerateReportModal;
